module.exports = __webpack_public_path__ + "static/img/6543213.735c7369.png";